import React, { useEffect } from "react";
import { Link } from "react-router-dom";

export default function UnauthorizedPage() {
	useEffect(() => { document.title = "Sin acceso | Somnus"; return () => { document.title = "Somnus"; }; }, []);
	return (
		<div className="container-fluid d-flex flex-column align-items-center justify-content-center min-vh-100  font-n">
			<div className="text-center p-3" style={{ maxWidth: '500px' }}>
				<h1 className="fw-bold mb-2" style={{color: 'var(--dark-blue)', fontSize: '55px', letterSpacing: '-2px'}}>Sin acceso</h1>
				
				<h4 className=" fw-bold mb-3" style={{ color: 'var(--font)' }}>No tienes permiso para ver esta página.</h4>
				
				<p className="text-muted">
					Si crees que es un error, inicia sesión con otra cuenta.
				</p>
				<div className="d-flex  justify-content-center  ">
					<div className="btn-back-container gap-2">
						<Link to="/" className="home "><span className="acceso-none">Ir al inicio</span></Link>
						<Link to="/login" className="admin-btn" ><span style={{color: 'var(--font)'}}>Iniciar sesión</span></Link>
					</div>
				</div>
				
			</div>
			<p className="mt-4 small text-muted">Somnus &copy; 2026</p>
		</div>
	);
}
